import React, { useContext } from 'react';
import "./examChargesStyles.scss";
import { PermisionDenied } from '../../common/commonComponents';
import { useParams } from 'react-router';
import StudentExamCharges from './StudentExamCharges';
import { PermissionContext, RolePermissions } from '../../../../../appContext';
import { pages } from '../../common/constant';

const ExamChargesLandingPage = () => {

    const { psid } = useParams();

    const permissions = useContext(PermissionContext);
    const userPermissions = RolePermissions(permissions, pages["studentExamCharges"]['id']);

    return (
        userPermissions
            ? <StudentExamCharges key={psid} />
            : <PermisionDenied />

    )
}

export default ExamChargesLandingPage;